import { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import DynamicTabsComponent from '../../components/DynamicTabs/DynamicTabsComponent';
import WorkReports from './ViewWorkReport';
import UserCourseReportsComponent from '../CourseReports/UserCourseReportsComponent';

const UserWorkReportsTabs = [
  {
    title: 'Work Reports',
    index: 0,
    component: <WorkReports />,
  },
  {
    title: 'Course Reports',
    index: 1,
    component: <UserCourseReportsComponent />,
  },
];

const UserWorkReportsComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState(() => {
    return location.search.includes('tab=work') ? 0 : 1;
  });

  useEffect(() => {
    if (!location.search.includes('tab=')) {
      navigate('/user-work-reports?tab=course', { replace: true });
    }
  }, [location.search, navigate]);

  const handleTabChange = (newTab) => {
    setActiveTab(newTab);
    navigate(`/user-work-reports?tab=${newTab === 1 ? 'course' : 'work'}`, {
      replace: true,
    });
  };

  return (
    <Box className="main-content-overlay">
      <div className="main-content-div">
        <DynamicTabsComponent
          activeTab={activeTab}
          setActiveTab={handleTabChange}
          TabsList={UserWorkReportsTabs}
        />
      </div>
    </Box>
  );
};

export default UserWorkReportsComponent;
